var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { HelpIconComponent } from './HelpIcon';
import { Grid } from '@material-ui/core';
import { TextOverflow } from './TextOverflow';
import { KEYS, i18n } from '../i18n';
import { theme } from '../theme';
export default (function (_a) {
    var label = _a.label, props = __rest(_a, ["label"]);
    return (React.createElement(Grid, { container: true, alignItems: "center", style: !props.v1 ? {} : { width: 'initial', marginRight: 2, height: 'fit-content' } },
        React.createElement(HelpIconComponent, { infoV2: true, style: !props.v1 ? {} : { width: 14, height: 14, marginRight: 2, marginTop: -1 }, title: i18n.getResource(i18n.language, KEYS.APP, label) }),
        React.createElement(TextOverflow, { title: i18n.getResource(i18n.language, KEYS.APP, label), variant: props.variant || (props.v1 ? 'caption' : 'subtitle1'), style: __assign(__assign({}, (!props.v1 ? {} : { fontSize: "0.5rem" })), { color: theme.palette.primary.light }) }, i18n.getResource(i18n.language, KEYS.APP, label + "_short"))));
});
